<template>
  <ion-card :color="color" :id="id">
    <img :src="image" />
    <ion-card-header>
      <ion-card-title>{{ this.title }}</ion-card-title>
    </ion-card-header>
  </ion-card>
</template>
<style lang="scss" scoped>
ion-card-title {
  font-weight: 500;
  font-size: 20px;
}
</style>
<script>
export default {
  name: "card",
  props: ["id", "color", "group", "spokenText", "type", "title", "image"],
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
